import React from 'react';
import KanbanCard from './KanbanCard';

/**
 * react-window v2 row component for virtualized kanban columns.
 * Wraps a KanbanCard with the row container and gap padding.
 */
const VirtualKanbanRow = ({
  index,
  style,
  ariaAttributes,
  items,
  selectedAppId,
  dragAppId,
  highlightedAppId,
  onSelect,
  onDragStart,
  onDragEnd,
}) => {
  const app = items[index];
  if (!app) return null;
  return (
    <div style={style} className="px-2" {...ariaAttributes}>
      <div className="pb-2">
        <KanbanCard
          app={app}
          isSelected={selectedAppId === app.id}
          isDragging={dragAppId === app.id}
          isHighlighted={highlightedAppId === app.id}
          onSelect={onSelect}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
        />
      </div>
    </div>
  );
};

export default VirtualKanbanRow;
